import styled from "styled-components";
import { Button } from "../../../../components";

export const DownloadCartilhaButton = styled(Button)`
  width: 100%;
`;

export const FormContent = styled.div({
  width: "100%",
  maxWidth: "384px",
});

export default DownloadCartilhaButton;
